import React from 'react';
import { Timeline as TimelinePrime } from 'primereact/timeline';
import RelatorioCollapse from '../../../components/relatorioCollapse/RelatorioCollapse';
import styles from './Timeline.module.scss';

function Timeline({ events }) {
    const getColor = (registroReprovacao, index) => {
        if (registroReprovacao) {
            return '#cd2d2d';
        }
        return index === events.length - 1 ? '#df950e' : '#1cdd1c';
    };

    const customizedMarker = ({ registroReprovacao }, index) => (
        <span
            className={styles.customMark}
            style={{ backgroundColor: getColor(registroReprovacao, index) }}
        />
    );

    return (
        <TimelinePrime
            className={styles.timeline}
            value={events}
            marker={customizedMarker}
            content={(props) => <RelatorioCollapse {...props} />}
        />
    );
}

export default Timeline;
